import {
  GET_CHANCE_GAMES_ACTIVE_DRAW_REQUEST,
  GET_CHANCE_GAMES_ACTIVE_DRAW_SUCCESS,
  GET_CHANCE_GAMES_ACTIVE_DRAW_FAILURE,
  GET_CHANCE_GAMES_DRAW_LIST_REQUEST,
  GET_CHANCE_GAMES_DRAW_LIST_SUCCESS,
  GET_CHANCE_GAMES_DRAW_LIST_FAILURE,
  GET_CHANCE_GAMES_DRAW_PRIZE_REQUEST,
  GET_CHANCE_GAMES_DRAW_PRIZE_SUCCESS,
  GET_CHANCE_GAMES_DRAW_PRIZE_FAILURE,
  GET_DRAWS_REQUEST,
  GET_DRAWS_SUCCESS,
  GET_DRAWS_FAILURE,
  GET_DRAWS_BY_ID_REQUEST,
  GET_DRAWS_BY_ID_SUCCESS,
  GET_DRAWS_BY_ID_FAILURE,
  RAFFLE_BUY_TICKET_REQUEST,
  RAFFLE_BUY_TICKET_SUCCESS,
  RAFFLE_BUY_TICKET_FAILURE,
  GET_TICKET_COUNT_REQUEST,
  GET_TICKET_COUNT_SUCCESS,
  GET_TICKET_COUNT_FAILURE
} from 'Store/constants';

const initialState = {
  activeDrawInfo: {
    data: {}, isFetched: false, isLoading: false, error: null
  },
  drawList: {
    list: [], isFetched: false, isLoading: false, error: null
  },
  drawPrize: {
    data: {}, isFetched: false, isLoading: false, error: null
  },
  draws: {
    data: {}, isFetched: false, isLoading: false, error: null
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CHANCE_GAMES_ACTIVE_DRAW_REQUEST:
      return { ...state,
        activeDrawInfo: {
          ...state.activeDrawInfo,
          isLoading: true,
          isFetched: false,
          error: null
        }
      };
    case GET_CHANCE_GAMES_ACTIVE_DRAW_SUCCESS:
      return {
        ...state,
        activeDrawInfo: {
          data: action.payload,
          isFetched: true,
          isLoading: false,
          error: null
        }
      };
    case GET_CHANCE_GAMES_ACTIVE_DRAW_FAILURE:
      return {
        ...state,
        activeDrawInfo: {
          ...state.activeDrawInfo,
          isFetched: true,
          isLoading: false,
          error: action.payload
        }
      };

    case GET_CHANCE_GAMES_DRAW_LIST_REQUEST:
      return { ...state,
        drawList: {
          ...state.drawList,
          isLoading: true,
          isFetched: false,
          error: null
        }
      };
    case GET_CHANCE_GAMES_DRAW_LIST_SUCCESS:
      return {
        ...state,
        drawList: {
          list: action.payload,
          isFetched: true,
          isLoading: false,
          error: null
        }
      };
    case GET_CHANCE_GAMES_DRAW_LIST_FAILURE:
      return {
        ...state,
        drawList: {
          ...state.drawList,
          isFetched: true,
          isLoading: false,
          error: action.payload
        }
      };

    case GET_CHANCE_GAMES_DRAW_PRIZE_REQUEST:
      return { ...state,
        drawPrize: {
          ...state.drawPrize,
          isLoading: true,
          isFetched: false,
          error: null
        }
      };
    case GET_CHANCE_GAMES_DRAW_PRIZE_SUCCESS:
      return {
        ...state,
        drawPrize: {
          data: action.payload,
          isFetched: true,
          isLoading: false,
          error: null
        }
      };
    case GET_CHANCE_GAMES_DRAW_PRIZE_FAILURE:
      return {
        ...state,
        drawPrize: {
          ...state.drawPrize,
          isFetched: true,
          isLoading: false,
          error: action.payload
        }
      };
    case GET_DRAWS_REQUEST:
      return { ...state,
        draws: {
          ...state.draws,
          isLoading: true,
          isFetched: false,
          error: null
        }
      };
    case GET_DRAWS_SUCCESS:
      return {
        ...state,
        draws: {
          data: action.payload,
          isFetched: true,
          isLoading: false,
          error: null
        }
      };
    case GET_DRAWS_FAILURE:
      return {
        ...state,
        draws: {
          ...state.draws,
          isFetched: true,
          isLoading: false,
          error: action.payload
        }
      };

    case GET_DRAWS_BY_ID_REQUEST:
      return { ...state,
        isLoading: true,
        isFetched: false,
        error: null
       
      };
    case GET_DRAWS_BY_ID_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isFetched: true,
        isLoading: false,
        error: null
      };
    case GET_DRAWS_BY_ID_FAILURE:
      return {
        ...state,
        isFetched: true,
        isLoading: false,
        error: action.payload
      };

    case RAFFLE_BUY_TICKET_REQUEST:
      return { ...state,
        isLoading: true,
        isFetched: false,
        error: null
         
      };
    case RAFFLE_BUY_TICKET_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isFetched: true,
        isLoading: false,
        error: null
      };
    case RAFFLE_BUY_TICKET_FAILURE:
      return {
        ...state,
        isFetched: true,
        isLoading: false,
        error: action.payload
      };
    case GET_TICKET_COUNT_REQUEST:
      return { ...state,
        isLoading: true,
        isFetched: false,
        error: null
           
      };
    case GET_TICKET_COUNT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isFetched: true,
        isLoading: false,
        error: null
      };
    case GET_TICKET_COUNT_FAILURE:
      return {
        ...state,
        isFetched: true,
        isLoading: false,
        error: action.payload
      };
    
    default:
      return state;
  }
};
